module.exports = __webpack_public_path__ + "img/icone_menu.5ede8e6c.svg";